export const mailAddresses = [
  "marcus.persson@climatemachines.com",
  "kenneth.andersson@climatemachines.com",
];
export const mailSubject = "New use of Climate Machines Product Configurator";
export const mailBody = `<h3>New Product Configurator use logged</h3>
  <p>
    A new user has run and saved a simulation on the Climate Machines Product
    Configurator.
  </p>
  <p>
    Log in to
    <a
      href="https://climatemachines.web.app/admin"
      target="_blank"
      rel="noopener noreferrer"
    >
      climatemachines.web.app/admin</a
    > and access the list of app uses through the user icon located in the header
    to see more info.
  </p>
  <p style="color: darkgray; font-size: 0.8rem; margin-top: 3rem;">
    This mail was auto-generated.
</p>`;
